import { DASHBOARD_RESOURCES } from 'constant';
import usePermission from 'commons-ui/src/permission/usePermission';
import { GET_ACTION, EAthenaDashboardResources } from './helper';

const useAthenaDashboardHome = () => {
	const { hasPermission } = usePermission();
	const isEnabled = (subEntity: string) => {
		return hasPermission({
			configPageName: DASHBOARD_RESOURCES.athenaDashboard,
			configResourceName: EAthenaDashboardResources.REQUEST_LIST,
			configActionName: GET_ACTION[subEntity]
		});
	};
	return { isEnabled };
};

export default useAthenaDashboardHome;
